/**
 * Stable, machine-readable error codes. The web client switches on these
 * rather than parsing English messages.
 */
export const ERROR_CODES = {
    // auth
    INVALID_CREDENTIALS: 'INVALID_CREDENTIALS',
    ACCOUNT_LOCKED: 'ACCOUNT_LOCKED',
    ACCOUNT_SUSPENDED: 'ACCOUNT_SUSPENDED',
    OTP_REQUIRED: 'OTP_REQUIRED',
    OTP_INVALID: 'OTP_INVALID',
    OTP_EXPIRED: 'OTP_EXPIRED',
    OTP_TOO_MANY_ATTEMPTS: 'OTP_TOO_MANY_ATTEMPTS',
    PASSWORD_CHANGE_REQUIRED: 'PASSWORD_CHANGE_REQUIRED',
    ONBOARDING_REQUIRED: 'ONBOARDING_REQUIRED',
    TOKEN_EXPIRED: 'TOKEN_EXPIRED',
    TOKEN_INVALID: 'TOKEN_INVALID',
    SESSION_REVOKED: 'SESSION_REVOKED',
    REFRESH_REPLAY_DETECTED: 'REFRESH_REPLAY_DETECTED',
    // authz
    FORBIDDEN: 'FORBIDDEN',
    UNAUTHENTICATED: 'UNAUTHENTICATED',
    // resources
    NOT_FOUND: 'NOT_FOUND',
    CONFLICT: 'CONFLICT',
    VALIDATION_FAILED: 'VALIDATION_FAILED',
    // mailbox
    IMAP_AUTH_FAILED: 'IMAP_AUTH_FAILED',
    IMAP_CONNECTION_FAILED: 'IMAP_CONNECTION_FAILED',
    MAILBOX_LIMIT_REACHED: 'MAILBOX_LIMIT_REACHED',
    // infra
    RATE_LIMITED: 'RATE_LIMITED',
    INTERNAL_ERROR: 'INTERNAL_ERROR',
    SERVICE_UNAVAILABLE: 'SERVICE_UNAVAILABLE',
};
//# sourceMappingURL=errors.js.map